import * as yup from 'yup';

import { FileTypeEnum } from 'app/graphql/generated/graphqlApolloTypes';

import { ConfigurationActionType, ConfigurationDestTableType, ConfigurationImportMethodType } from 'app/models';

import { formatMessage } from 'utils/messages/utils';

export const validationSchema = (existingTableNames: string[]) =>
  yup.object().shape({
    configurationId: yup.number().nullable().when('configurationAction', {
      is: ConfigurationActionType.RUN,
      then: yup.number().required()
    }),
    configurationAction: yup.string(),
    destinationTable: yup.string().when(['dataTableType', 'configurationImportMethodType', 'destinationTableType'], {
      is: (dataTableType, configurationImportMethodType, destinationTableType) =>
        dataTableType.value === FileTypeEnum.Activity &&
        (configurationImportMethodType === ConfigurationImportMethodType.CREATE ||
          (configurationImportMethodType === ConfigurationImportMethodType.REPLACE &&
            destinationTableType === ConfigurationDestTableType.NEW)),
      then: (schema) =>
        schema
          .required(formatMessage('DESTINATION_TABLE_REQUIRED'))
          .notOneOf(existingTableNames, formatMessage('TABLE_NAME_ALREADY_EXISTS'))
    }),

    symonExportNode: yup.object().required(formatMessage('SYMON_EXPORT_NODE_REQUIRED')).nullable(),
    symonPipeName: yup.object().required(formatMessage('SYMON_PIPE_NAME_REQUIRED')).nullable()
  });
